import PartnerGlobalPicker from './PartnerGlobalPicker';

export default PartnerGlobalPicker;
